module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"items":""},"ja":{"items":"件"}}')
  delete Component.options._Ctor
}
